import Vue from "vue";
import {APIHOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class ReportService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }


    getBranchPostIndexReport({client, start, end, date, regionId, areaId, selectedFilters, selectedPostIndexes, isAllClientsSelected, type, clients}) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            regionId: regionId ? regionId : null,
            areaId: areaId ? areaId : null,
            date: date ? date.format("YYYY-MM") : null,
            selectedFilters: selectedFilters ? selectedFilters : null,
            selectedPostIndexes: selectedPostIndexes ? selectedPostIndexes : null,
            isAllClientsSelected: isAllClientsSelected,
            isArchive: type,
            clients: clients
        };

        return Vue.axios.post(`${APIHOST}/api/BranchPostIndexReport`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
            timeout: 1800000
        });
    }


    getPagesCountAreaReport({client, start, end, date, regionId, selectedFilters, selectedAreas, isAllClientsSelected, type, clients}) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            regionId: regionId ? regionId : null,
            date: date ? date.format("YYYY-MM") : null,
            selectedFilters: selectedFilters ? selectedFilters : null,
            selectedAreas: selectedAreas ? selectedAreas : null,
            isAllClientsSelected: isAllClientsSelected,
            isArchive: type,
            clients: clients
        };

        return Vue.axios.post(`${APIHOST}/api/ProcessingPagesCountAreaReport`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getBranchAreaReport({client, start, end, date, regionId, selectedFilters, selectedAreas, isAllClientsSelected, type, clients}) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            regionId: regionId ? regionId : null,
            date: date ? date.format("YYYY-MM") : null,
            selectedFilters: selectedFilters ? selectedFilters : null,
            selectedAreas: selectedAreas ? selectedAreas : null,
            isAllClientsSelected: isAllClientsSelected,
            isArchive: type,
            clients: clients
        };

        return Vue.axios.post(`${APIHOST}/api/BranchAreaReport`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
            timeout: 1800000
        });
    }

    getTaskPerformanceAreaReport({client, start, end, date, regionId, selectedFilters, selectedAreas, isAllClientsSelected, type, clients}) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            regionId: regionId ? regionId : null,
            date: date ? date.format("YYYY-MM") : null,
            selectedFilters: selectedFilters ? selectedFilters : null,
            selectedAreas: selectedAreas ? selectedAreas : null,
            isAllClientsSelected: isAllClientsSelected,
            isArchive: type,
            clients: clients
        };

        return Vue.axios.post(`${APIHOST}/api/ArealTaskPerformanceReport`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getPagesCountRegionReport({ client, start, end }) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null
        };

        return Vue.axios.post(`${APIHOST}/api/PagesCountReport`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getPagesSumRegionReport({ client, start, end }) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null
        };

        return Vue.axios.post(`${APIHOST}/api/PagesSumReport`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }


    getPagesEconomistReport({ client, start, end }) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null
        };

        return Vue.axios.post(`${APIHOST}/api/EconomistStatisticsReport`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getBranchRegionReport({ client, start, end, date, selectedFilters, selectedRegions, isAllClientsSelected, type, clients }) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            date: date ? date.format("YYYY-MM") : null,
            selectedFilters: selectedFilters ? selectedFilters : null,
            selectedRegions: selectedRegions ? selectedRegions : null,
            isAllClientsSelected: isAllClientsSelected,
            isArchive: type,
            clients: clients
        };

        return Vue.axios.post(`${APIHOST}/api/BranchRegionReport`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
            timeout: 1800000
        });
    }

    getTaskPerformanceRegionReport({ client, start, end, date, selectedFilters, selectedRegions, isAllClientsSelected, type, clients }) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            date: date ? date.format("YYYY-MM") : null,
            selectedFilters: selectedFilters ? selectedFilters : null,
            selectedRegions: selectedRegions ? selectedRegions : null,
            isAllClientsSelected: isAllClientsSelected,
            isArchive: type,
            clients: clients
        };

        return Vue.axios.post(`${APIHOST}/api/RegionalTaskPerformanceReport`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }


    getPerformReport({ client, start, end, date, selectedFilters, selectedRegions, isAllClientsSelected, type, clients }) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            date: date ? date.format("YYYY-MM") : null,
            username: $store.getters.appLogin.username,
            selectedFilters: selectedFilters ? selectedFilters : null,
            selectedRegions: selectedRegions ? selectedRegions : null,
            isAllClientsSelected: isAllClientsSelected,
            isArchive: type,
            clients: clients
        };

        return Vue.axios.post(`${APIHOST}/api/PerformsReport`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getPerformAreaReport({ client, start, end, date, regionId, selectedFilters, selectedAreas, isAllClientsSelected, type, clients }) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            date: date ? date.format("YYYY-MM") : null,
            regionId : regionId,
            username: $store.getters.appLogin.username,
            selectedFilters: selectedFilters ? selectedFilters : null,
            selectedAreas: selectedAreas ? selectedAreas : null,
            isAllClientsSelected: isAllClientsSelected,
            isArchive: type,
            clients: clients
        };

        return Vue.axios.post(`${APIHOST}/api/PerformsAreaReport`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getClientIncomingRegionReport({start, end, date, selectedRegions, selectedClients, isSelectAllRegions, isSelectAllClients, type}) {
        const requestBody = {
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            selectedRegions: selectedRegions,
            date: date ? date.format("YYYY-MM") : null,
            username: $store.getters.appLogin.username,
            isArchive: type,
            selectedClients: selectedClients,
            isSelectAllRegions: isSelectAllRegions,
            isSelectAllClients: isSelectAllClients
        };

        return Vue.axios.post(`${APIHOST}/api/ClientIncomingRegionReport`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
            timeout: 1800000
        });
    }

    getClientIncomingAreaReport({start, end, date, regionId, selectedAreas, selectedClients, type}) {
        const requestBody = {
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            selectedAreas: selectedAreas,
            date: date ? date.format("YYYY-MM") : null,
            regionId: regionId,
            isArchive: type,
            selectedClients: selectedClients,
        };

        return Vue.axios.post(`${APIHOST}/api/ClientIncomingRegionArea`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
            timeout: 1800000
        });
    }

    getDeliveredReport({client, start, date, end, regionId, areaId, isAllClientsSelected, selectedFilters, type}) {
        return Vue.axios.post(`${APIHOST}/api/DeliveredReport`, {
            regionId: regionId ? regionId : null,
            areaId: areaId ? areaId : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            client: client ? client.id : null,
            username: $store.getters.appLogin.username,
            isAllClientsSelected: isAllClientsSelected,
            date: date ? date.format("YYYY-MM") : null,
            selectedFilters: selectedFilters ? selectedFilters : null,
            isArchive: type
        },{



            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
            timeout: 1800000
        });
    }


    getClientReport({client, start, end, date, selectedFilters, selectedClients, type}) {
        const requestBody = {
            client: client ? client.id : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            date: date ? date.format("YYYY-MM") : null,
            selectedFilters: selectedFilters ? selectedFilters : null,
            selectedClients: selectedClients ? selectedClients : null,
            isArchive: type
        };

        return Vue.axios.post(`${APIHOST}/api/ClientsReport`, requestBody, {
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
            timeout: 1800000
        });
    }

    getUsersReport({start, end, date, regionId, selectedFilters, type, postIndex, isAllClientsSelected ,client}) {
        return Vue.axios.post(`${APIHOST}/api/UsersReport`, {
            client: client ? client.id : null,
            regionId: regionId ? regionId : null,
            start: start ? start.format("YYYY-MM-DD") : null,
            end: end ? end.format("YYYY-MM-DD") : null,
            date: date ? date.format("YYYY-MM") : null,
            selectedFilters: selectedFilters ? selectedFilters : null,
            isArchive: type,
            postIndex: postIndex ? postIndex : null,
            isAllClientsSelected: isAllClientsSelected
        },{
            headers: {
                "Authorization": `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
            timeout: 1800000
        });
    }
}

export default new ReportService()
